<template>
  <svg
    width="10px"
    height="6px"
    viewBox="0 0 10 6"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>箭头</title>
    <desc>Created with Sketch.</desc>
    <g id="订单" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M2.83605839,8 L2.8360584,8 C2.46452503,7.99850333 2.16454358,7.6961119 2.16602963,7.32457853 C2.166737,7.14775248 2.23703729,6.97831444 2.36171996,6.85292548 L6.21608456,3.00004566 L2.36171996,-0.854318943 L2.36171994,-0.854318961 C2.09974992,-1.11670114 2.10008399,-1.54177204 2.36246581,-1.80374078 C2.62484798,-2.06571081 3.04991888,-2.06537673 3.31188763,-1.80299494 L7.637616,2.52273344 L7.63761604,2.52273347 C7.89958606,2.78386383 7.90026573,3.20791971 7.63913583,3.46988974 C7.63863002,3.47039717 7.6381234,3.4709038 7.63761596,3.47140961 L3.31188759,7.79713798 L3.3118876,7.79713796 C3.18684449,7.92575246 3.01543376,7.9988301 2.83605799,8 L2.83605839,8 Z"
        id="箭头"
        fill="#999999"
        fill-rule="nonzero"
        transform="translate(5.000000, 3.000000) rotate(90.000000) translate(-5.000000, -3.000000) "
      ></path>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SelectArrowSvg'
});
</script>
